import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { TokenService } from './token.service';
import { Observable, Subject } from 'rxjs';

declare const Pusher: any;

@Injectable({
  providedIn: 'root'
})
export class PusherService {

  public socket: any;

  public fresh$: Observable<any>;

  private freshSubject = new Subject<void>();

  constructor(private tokenService: TokenService) { 
    this.boot(true);
    this.fresh$ = this.freshSubject.asObservable();
  }

  public boot(initial = false): void {
    if (this.socket) {
      this.socket.allChannels().forEach(channel => {
        channel.unbind();
        this.socket.unsubscribe(channel.name);
      });
      // this.socket.disconnect();
    }
    if (!initial) {
      setTimeout(() => {
        this.initializeSocket(false);
      }, 2000);
    } else {
      this.initializeSocket(true)
    }
  }

  private initializeSocket(initial: boolean): void {
    if (this.socket) this.socket.disconnect();
    this.socket = new Pusher(environment.pusher.key, {
      cluster: environment.pusher.cluster,
      authEndpoint: environment.pusher.authEndpoint,
      forceTLS: environment.pusher.forceTLS,
      auth: {
        headers: {
          Authorization: `Bearer ${this.tokenService.get()}`,
          Accept: 'application/json'
        }
      }
    });
    if (!initial) this.freshSubject.next();
    console.log('Pusher initialized');
  }

}
